exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-tags__selected-tag{display:inline-block;box-sizing:border-box;margin:0 6px 6px 0;padding:6px 8px;border:1px solid #d1d1d1;border-radius:2px;background:#f1f1f1;font-size:14px}.react-tags__selected-tag:after{content:\"\\2715\";color:#aaa;margin-left:8px}.react-tags__selected-tag:focus,.react-tags__selected-tag:hover{border-color:#b1b1b1}.react-tags__search input{width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;outline:none}.react-tags__suggestions{position:absolute;background-color:#fff;padding:6px 12px;border:1px solid #ccc}.react-tags__suggestions ul{list-style-type:none;margin:0;padding:0;font-size:14px}.react-tags__suggestions li mark{color:#00aeef;text-decoration:underline;background:none}.react-tags__suggestions li:hover{cursor:pointer;background:#eee}", ""]);

// exports
exports.locals = {
	"tagAutocomplete": "tag-autocomplete__tagAutocomplete___1elO7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/tag-autocomplete.scss
// module id = 1078
// module chunks = 0